import { createContext, useContext, ReactNode } from 'react';
import { ChatInstance } from './ChatInstance';

interface AgentChatInstanceContextValue {
  chatInstanceId: ChatInstance;
}

const AgentChatInstanceContext = createContext<AgentChatInstanceContextValue | null>(null);

interface AgentChatInstanceProviderProps {
  children: ReactNode;
  instanceId: ChatInstance;
}

export const AgentChatInstanceProvider = ({
  children,
  instanceId,
}: AgentChatInstanceProviderProps) => {
  return (
    <AgentChatInstanceContext.Provider value={{ chatInstanceId: instanceId }}>
      {children}
    </AgentChatInstanceContext.Provider>
  );
};

export const useAgentChatInstance = (): AgentChatInstanceContextValue => {
  const context = useContext(AgentChatInstanceContext);
  if (!context) {
    throw new Error('useAgentChatInstance must be used within an AgentChatInstanceProvider');
  }
  return context;
};

// Optional version that returns null if not within provider (for use in dialogs/portals)
export const useAgentChatInstanceOptional = (): AgentChatInstanceContextValue | null => {
  return useContext(AgentChatInstanceContext);
};
